import { FC, useState } from 'react';

import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { Input } from '@/components/ui/Input';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const COMPANY_NAME_NAME = 'company_name';

interface Props {
  name?: string;
}

const InputCompanyName: FC<Props> = ({ name = COMPANY_NAME_NAME }) => {
  const { i18n } = useLingui();
  const { control, trigger } = useFormContext();
  const [focused, setFocused] = useState(false);

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        validate: (v, form) =>
          form.is_company && !v?.trim() ? i18n.t('Uzupełnij to pole') : true,
      }}
      render={({
        field: { onBlur, onChange, ...field },
        fieldState: { error },
      }) => (
        <FormItem>
          <FormControl>
            <Input
              label={i18n.t('Nazwa firmy')}
              error={error?.message}
              success={!focused && !error && !!field.value}
              autoComplete="organization"
              onFocus={() => setFocused(true)}
              onBlur={() => {
                setFocused(false);
                onBlur();
              }}
              onChange={(e) => {
                onChange(e);
                if (error) trigger(name);
              }}
              {...field}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default InputCompanyName;
